import { useLazyGetFrontDeskPosCustomers, useLazyGetPosCustomers } from 'api/posCustomerApi';
import { PeakModules } from 'common/constants/peakModules';

type LazyTrigger<T> = (args: T) => any;

export type TSearchPosCustomerReturn = LazyTrigger<{ search: string; page: number }>;

const useSearchPosCustomers = (
  module: PeakModules = PeakModules.FrontDesk,
): TSearchPosCustomerReturn => {
  const [getFrontDeskPosCustomers] = useLazyGetFrontDeskPosCustomers();
  const [getPosCustomers] = useLazyGetPosCustomers();

  if (module === PeakModules.FrontDesk) {
    return getFrontDeskPosCustomers;
  } else {
    return getPosCustomers;
  }
};

export default useSearchPosCustomers;
